<template>
    <div>
        <v-container fluid v-if="customers" class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Customers</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                        v-if="hasPermission('customer-create')"
                        color="info"
                        dark
                        class="mb-2"
                        :to="{name: 'customer-create'}"

                >
                    <i class="fas fa-plus mr-2"></i> New Customer
                </v-btn>
            </div>
            <v-card>
                <v-card-title>

                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <v-data-table
                        :loading="this.$apollo.queries.customers.loading"
                        :headers="headers"
                        :items="customers.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="customers.paginatorInfo.lastPage * pageCount"
                >
                    <template v-slot:item.company="{ item }">
                        <router-link :to="{name: 'customer-view', params: {id: item.id}}" small>
                            {{item.company}}
                        </router-link>
                    </template>

                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import CUSTOMERS_LIST from "../graphql/Customer/List.gql";
    import Dashboard from "../layouts/Dashboard";
    import {mapGetters} from "vuex";

    export default {
        metaInfo: {
            title: 'Customers'
        },
        created() {
            this.$emit('update:layout', Dashboard);
        },
        apollo: {
            customers: {
                query: CUSTOMERS_LIST,
                variables() {

                    let where = {column: 'COMPANY', operator: 'IS_NOT_NULL'}
                    if (this.search !== '') {
                        where = {column: 'COMPANY', operator: 'LIKE', value: '%' + this.search + '%'}
                    }

                    let sortField = this.sortBy[0] ? this.sortBy[0] : 'Customer_I_D'
                    let sortDirection = this.sortDesc[0] ? 'DESC' : 'ASC'

                    if (sortField === 'contactName') {
                        sortField = 'Contact_Name'
                    }

                    if (sortField === 'contactTown') {
                        sortField = 'Town'
                    }

                    if (sortField === 'contactPostcode') {
                        sortField = 'PostCode'
                    }


                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: sortField.toUpperCase(), order: sortDirection},
                    }
                },
                update: data => data.customers
            },
        },
        computed: {
            ...mapGetters('auth', [
                'hasPermission',
            ]),
        },
        data() {
            return {
                search: '',
                page: 1,
                pageCount: 15,
                sortBy: ['company'],
                sortDesc: [false],
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        value: 'id',
                    },
                    {
                        text: 'Company',
                        align: 'start',
                        value: 'company',
                    },
                    {
                        text: 'Contact',
                        align: 'start',
                        value: 'contactName',
                    },
                    {
                        text: 'Town',
                        align: 'start',
                        value: 'contactTown',
                    },
                    {
                        text: 'Postcode',
                        align: 'start',
                        value: 'contactPostcode',
                    }
                ],
            }
        },
    }
</script>
